import { ACCESS_TOKEN, Core, SURVEY_LOOKUPS, SURVEY_SUBMIT } from '@services/Core';
import { AxiosPromise } from 'axios';

const SURVEY_TOKEN = process.env.REACT_APP_SURVEY_TOKEN;

interface GetAccessToken {
  (): AxiosPromise<{ access_token: string }>;
}

interface GetLookups {
  (requestId: string, token: string): AxiosPromise;
}

interface SubmitSurveyForm {
  (requestId: string, data: FormData, token: string, recaptchaToken: string): AxiosPromise<string>;
}

class Survey extends Core {
  getAccessToken: GetAccessToken = async () => {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'client_credentials');
    return this.post(`${ACCESS_TOKEN}`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${SURVEY_TOKEN}`,
      },
      transformRequest: [
        (data, headers) => {
          headers['Content-Type'] = 'application/x-www-form-urlencoded';
          return data;
        },
      ],
    });
  };
  getSurveyLookups: GetLookups = async (requestId, token) => {
    return this.get(SURVEY_LOOKUPS(requestId), {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  submitSurveyForm: SubmitSurveyForm = async (requestId, data, token, recaptchaToken) => {
    return this.post(SURVEY_SUBMIT(requestId), data, {
      headers: { Authorization: `Bearer ${token}` },
      params: { recaptchaToken },
    });
  };
}

export const survey = new Survey();
